import { useGetInspectorQuery } from 'app/api_v2/agency/queries';
import { useAuthStore } from 'app/core/store_v2/auth';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import { Box } from '@mui/material';

export interface InspectorProfileResolverProps {
  children: any;
}

export default function InspectorProfileResolver(props: InspectorProfileResolverProps) {
  const { children } = props;
  const { currentUser } = useAuthStore();
  const { id = '' } = useParams();

  const navigate = useNavigate();

  const [redirect, setRedirect] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);

  useEffect(() => {
    if (redirect !== '') {
      navigate(redirect);
      setRedirect('');
      setIsValid(true);
    }
  }, [redirect, navigate]);

  const { isLoading, isError, error, isSuccess } = useGetInspectorQuery(id || '', {
    enabled: id !== '' && Boolean(currentUser),
    gcTime: 1000,
  });

  useEffect(() => {
    if (isSuccess) {
      let redirect = '';

      // SETUP GUARDS
      // if (shouldUseGuards()) {
      //   redirect = agencyProfileResolverGuards(data, location, currentUser);
      // }

      if (redirect !== '') {
        setRedirect(redirect);
        setIsValid(false);
      } else {
        setIsValid(true);
      }
    }
  }, [isSuccess /*, location, data*/]);

  useEffect(() => {
    if (isError) {
      // just to show error message
      setIsValid(true);
    }
  }, [isError]);

  if (isLoading || !isValid) {
    return (
      <Box mt={4}>
        <DataLoader />
      </Box>
    );
  }

  if (!isLoading && isError) {
    return (
      <Box p={3}>
        <ErrorsList title="Unexpected loading error" errors={error as string[]} />
      </Box>
    );
  }

  return <>{children}</>;
}
